import React from 'react';
import { ShieldCheckIcon, XIcon } from 'lucide-react';
import { product } from '../data/article';
import { ArticleFigure } from './ArticleFigure';
import { Prose } from './Prose';
import { CtaButton } from './CtaButton';
export function ProductSection() {
  return <section className="px-5 py-10 sm:px-8 md:py-14" aria-labelledby="product-heading" data-id="element-37" data-mp="hl37xxn7arw1">
      <div className="mx-auto max-w-[42rem]" data-id="element-38" data-mp="cqgt1khwuh77">
        <p className="text-[12px] font-bold uppercase tracking-[0.22em] text-neutral-400" data-id="element-39" data-mp="qj6t2su9xmnb">
          {product.eyebrow}
        </p>
        <h2 id="product-heading" className="mt-3 text-[26px] font-extrabold leading-[1.2] tracking-[-0.02em] text-ink sm:text-[32px]" data-id="element-40" data-mp="mhtlad7mf9dr">
          {product.title}
        </h2>

      </div>

      <ArticleFigure image={product.image} className="mx-auto mt-7 max-w-3xl" data-id="element-41" data-mp="vgyjfif9t0pe" />

      <div className="mx-auto mt-8 max-w-[42rem]" data-id="element-42" data-mp="32a0zdn4gnm9j">
        <Prose blocks={product.blocks} data-id="element-43" data-mp="2xao36brp92ua" />

        <ul className="mt-7 grid gap-x-6 gap-y-2 sm:grid-cols-2" data-id="element-44" data-mp="2xbpn75qp0zo5">
          {product.noList.map(item => <li key={item} className="flex items-start gap-2 text-[16px] font-medium text-ink sm:text-[17px]" data-id="element-45" data-mp="3sjbn55oh77av">
              <XIcon className="mt-1 h-4 w-4 shrink-0 text-brand-600" aria-hidden="true" data-id="element-46" data-mp="1936gxw3jx4e" />
              {item}
            </li>)}
        </ul>
      </div>

      <div id="get-rylte" className="mx-auto mt-10 max-w-3xl scroll-mt-8" data-id="element-47" data-mp="a4j47pzz2wf9">
        <div className="rounded-lg bg-brand-700 p-7 text-white sm:p-10" data-id="element-48" data-mp="f33y77omsjv9">
          <p className="flex items-center gap-2 text-[12px] font-bold uppercase tracking-[0.2em] text-brand-100" data-id="element-49" data-mp="k1oxn4w26zin">
            <ShieldCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-50" data-mp="p11lnsyo2cmt" />
            Zero risk
          </p>
          <h3 className="mt-3 text-[28px] font-extrabold leading-tight tracking-[-0.02em] sm:text-[34px]" data-id="element-51" data-mp="t2vifq5qqwhp">
            {product.guarantee.label}
          </h3>
          <div className="mt-3 space-y-1" data-id="element-52" data-mp="2qu7wfv3fb0pt">
            {product.guarantee.lines.map(line => <p key={line} className="text-[18px] font-medium text-brand-100 sm:text-[19px]" data-id="element-53" data-mp="2uvt3v0x6umsm">
                {line}
              </p>)}
          </div>
          <p className="mt-5 max-w-[38rem] text-[16px] leading-relaxed text-brand-100 sm:text-[17px]" data-id="element-54" data-mp="3t6ktc0jexwe7">
            {product.guarantee.body}
          </p>
          <CtaButton className="mt-7" size="lg" tone="light" data-id="element-55" data-mp="6ycmwgl3roqq">
            {product.cta}
          </CtaButton>
        </div>
      </div>
    </section>;
}